import PropTypes from "prop-types";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getPrefetchedPhotos } from "app/pages/Listing/productsSelector";
import { useSelector, shallowEqual } from "react-redux";
import { getRobotsMetaTag, getSeoMetaData } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);

	return {
		prefetchedPhotos: getPrefetchedPhotos(state),
		robotsMetaTag: robotsMetaTag?.listing,
		titleFromSanity: getSeoMetaData("listing.metaTitle")(state),
		descriptionFromSanity: getSeoMetaData("listing.metaDescription")(state),
	};
};

const ListingHeadMetadata = ({ title: titleFromProps, description: descriptionFromProps }) => {
	const {
		prefetchedPhotos = [],
		robotsMetaTag = [],
		titleFromSanity,
		descriptionFromSanity,
	} = useSelector(mapStateToProps, shallowEqual);

	const title = titleFromSanity || titleFromProps;
	const description = descriptionFromSanity || descriptionFromProps;

	return (
		<HeadMetadata
			prefetchRessources={prefetchedPhotos}
			robotsMetaTag={robotsMetaTag}
			title={title}
			description={description}
		/>
	);
};

ListingHeadMetadata.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	titleFromSanity: PropTypes.string,
	descriptionFromSanity: PropTypes.string,
};

export default ListingHeadMetadata;
